import { extends as _extends } from './_virtual/_rollupPluginBabelHelpers.js';
import { withTUXIcon } from './withTUXIcon.js';
import * as React from 'react';

function IconChevronLeftOffsetLTR(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor"
  }, props, {
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    className: 'flip-rtl ' + (props.className ? props.className : '')
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.59 22.59l16.29-16.3a1 1 0 011.41 0l1.42 1.42a1 1 0 010 1.41L8.83 24 23.7 38.88a1 1 0 010 1.41l-1.42 1.42a1 1 0 01-1.41 0L4.58 25.4a2 2 0 010-2.82z"
  }));
}
var TUXIconChevronLeftOffsetLTR = withTUXIcon(IconChevronLeftOffsetLTR);

export default IconChevronLeftOffsetLTR;
export { TUXIconChevronLeftOffsetLTR };
